// PGCET MCA Mock 3 — Computer Awareness (questions 31–55), drawn from the Karnataka PGCET 2026 MCA paper
const pgcetmcaComputerAwareness = [
  {
    id: 31,
    question: `The primary classification of programming languages is
      (a) Machine language
      (b) Assembly language
      (c) High-level language
      (d) Pseudocode and algorithms`,
    options: [
      "A. Only (c) and (d) are correct",
      "B. Only (a) and (b) are correct",
      "C. Only (a), (b) and (c) are correct",
      "D. Only (a) and (d) are correct"
    ],
    answer: "C"
  },
  {
    id: 32,
    question: `Match List-I with List-II with respect to the connection between the processor and memory.
      List-I: (a) MAR (b) MDR (c) Address bus (d) Control bus
      List-II: (i) Carries the Read/Write and timing signals (ii) Unidirectional lines that carry the memory location to be accessed (iii) Holds the data being transferred to or from memory (iv) Holds the address of the memory location to be accessed`,
    options: [
      "A. a-iv, b-iii, c-ii, d-i",
      "B. a-iii, b-iv, c-ii, d-i",
      "C. a-iv, b-ii, c-iii, d-i",
      "D. a-ii, b-iii, c-iv, d-i"
    ],
    answer: "A"
  },
  {
    id: 33,
    question: "In the C statement b = 66.6 / a + 12 * n; which operation will be performed first?",
    options: ["A. 66.6 / a", "B. 12 * n", "C. a + 12", "D. Depends upon the compiler"],
    answer: "A"
  },
  {
    id: 34,
    question: "Consider the instruction ADD R1, R2, R3 in an assembly language where the first operand is the destination. What does the instruction do?",
    options: [
      "A. Adds the contents of R1 and R2 and places the sum in R3",
      "B. Adds the contents of R1, R2 and R3 and places the sum in another register",
      "C. Adds the contents of R2 and R3 and places the sum in R1",
      "D. The instruction is invalid"
    ],
    answer: "C"
  },
  {
    id: 35,
    question: "What is the meaning of a 16 × 8 organization with respect to a memory chip?",
    options: ["A. 8 words of 16 bits each", "B. 16 bits × 8 bits", "C. 16 words of 8 bits each", "D. 16 words of 8 bytes each"],
    answer: "C"
  },
  {
    id: 36,
    question: "Reservation clerks for airlines and hotels check availability for a given request and make reservations. With respect to database applications, these users are categorised as",
    options: ["A. Casual end users", "B. Parametric end users", "C. Sophisticated end users", "D. Standalone users"],
    answer: "B"
  },
  {
    id: 37,
    question: "Which data model organizes data as a collection of records with a fixed structure (fixed-format records)?",
    options: ["A. Relational data model", "B. Network data model", "C. Hierarchical data model", "D. Object data model"],
    answer: "A"
  },
  {
    id: 38,
    question: "Which language is used to define the logical, external and physical schemas and access authorizations?",
    options: [
      "A. Data Manipulation Language (DML)",
      "B. Data Definition Language (DDL)",
      "C. Logical Definition Language (LDL)",
      "D. Data-Driven Language"
    ],
    answer: "B"
  },
  {
    id: 39,
    question: `Arrange the following memories in increasing order of size.
      (a) Cache memory
      (b) Registers
      (c) Secondary memory
      (d) Primary memory`,
    options: ["A. (b), (a), (d), (c)", "B. (b), (a), (c), (d)", "C. (a), (b), (c), (d)", "D. (d), (b), (a), (c)"],
    answer: "A"
  },
  {
    id: 40,
    question: `The control unit of a computer goes through an instruction cycle divided into the following phases.
      (a) Fetch the instruction from memory
      (b) Decode the instruction
      (c) Execute the instruction`,
    options: ["A. Only (b) and (c) are correct", "B. Only (c) is correct", "C. Only (a) is correct", "D. (a), (b) and (c) are correct"],
    answer: "D"
  },
  {
    id: 41,
    question: "With respect to web applications, the full form of WAMP is",
    options: [
      "A. Windows, Apache, MySQL and PHP",
      "B. Word, Adobe, MySQL and PHP",
      "C. Windows, Apache, Mainstream and Program",
      "D. Windows, Adobe, MySQL and PHP"
    ],
    answer: "A"
  },
  {
    id: 42,
    question: `Which of the following are valid hexadecimal numbers?
      (i) 1A3F
      (ii) 29GF
      (iii) FF12
      (iv) 7BHE`,
    options: ["A. (i), (ii) and (iv)", "B. (i), (ii) and (iii)", "C. (i) and (iii)", "D. (i), (iii) and (iv)"],
    answer: "C"
  },
  {
    id: 43,
    question: "The decimal number (25)₁₀ is represented in binary as",
    options: ["A. 11001", "B. 10101", "C. 11100", "D. 10011"],
    answer: "A"
  },
  {
    id: 44,
    question: `Arrange the following steps in the correct order to convert a decimal number to binary.
      (i) Repeat the division until the quotient becomes 0
      (ii) Divide the number by 2
      (iii) Write down the remainder
      (iv) Write the remainders in reverse order`,
    options: ["A. (i) → (ii) → (iii) → (iv)", "B. (ii) → (iii) → (i) → (iv)", "C. (iii) → (i) → (iv) → (ii)", "D. (iv) → (ii) → (iii) → (i)"],
    answer: "B"
  },
  {
    id: 45,
    question: `Match the characters in List-I with their ASCII codes (decimal) in List-II.
      List-I: (a) 'A' (b) 'a' (c) '0' (d) Space
      List-II: (i) 48 (ii) 32 (iii) 65 (iv) 97`,
    options: [
      "A. a-i, b-iii, c-iv, d-ii",
      "B. a-i, b-iv, c-iii, d-ii",
      "C. a-iii, b-iv, c-i, d-ii",
      "D. a-iii, b-iv, c-ii, d-i"
    ],
    answer: "C"
  },
  {
    id: 46,
    question: `A floating-point number typically consists of
      (i) Sign bit
      (ii) Parity bit
      (iii) Mantissa (significand)
      (iv) Exponent`,
    options: ["A. (i), (ii) and (iv)", "B. (i), (iii) and (iv)", "C. (ii), (iii) and (iv)", "D. (i), (ii) and (iii)"],
    answer: "B"
  },
  {
    id: 47,
    question: `Arrange the steps to find the two's complement of a binary number.
      (i) Take the 1's complement
      (ii) Write the binary number
      (iii) Add 1
      (iv) Obtain the final result`,
    options: ["A. (iv) → (i) → (iii) → (ii)", "B. (ii) → (iii) → (i) → (iv)", "C. (ii) → (i) → (iii) → (iv)", "D. (i) → (ii) → (iii) → (iv)"],
    answer: "C"
  },
  {
    id: 48,
    question: "The result of (101)₂ × (10)₂ is",
    options: ["A. (1010)₂", "B. (1000)₂", "C. (1110)₂", "D. (1100)₂"],
    answer: "A"
  },
  {
    id: 49,
    question: `Match the binary operations in List-I with their results in List-II.
      List-I: (a) 1 + 1 (b) 1 + 1 + 1 (c) 10 − 1 (d) 1 × 0
      List-II: (i) 0 (ii) 10 (iii) 1 (iv) 11`,
    options: [
      "A. a-ii, b-i, c-iv, d-iii",
      "B. a-ii, b-iv, c-iii, d-i",
      "C. a-iv, b-ii, c-i, d-iii",
      "D. a-ii, b-iii, c-i, d-iv"
    ],
    answer: "B"
  },
  {
    id: 50,
    question: "Which CPU scheduling algorithm works on the principle of time slices?",
    options: ["A. FCFS", "B. Round Robin", "C. SJF", "D. Priority Scheduling"],
    answer: "B"
  },
  {
    id: 51,
    question: `Which of the following are characteristics of Real-Time Operating Systems (RTOS)?
      (i) Deterministic response
      (ii) High latency allowed
      (iii) Strict timing constraints
      (iv) Used in embedded systems`,
    options: ["A. (i) and (iii) only", "B. (i), (iii) and (iv) only", "C. (ii) and (iv) only", "D. (i), (ii) and (iii) only"],
    answer: "B"
  },
  {
    id: 52,
    question: `Arrange the process states in the order a process typically passes through them.
      (i) Running
      (ii) Ready
      (iii) New
      (iv) Waiting`,
    options: ["A. (i) → (ii) → (iii) → (iv)", "B. (iii) → (ii) → (i) → (iv)", "C. (iv) → (i) → (ii) → (iii)", "D. (ii) → (i) → (iii) → (iv)"],
    answer: "B"
  },
  {
    id: 53,
    question: `Match the operating systems in List-I with their characteristics in List-II.
      List-I: (a) Batch OS (b) Time-sharing OS (c) Distributed OS (d) Real-time OS
      List-II: (i) CPU time is shared among users through time slices (ii) Similar jobs are grouped and run without user interaction (iii) Responds to events within strict deadlines (iv) Several networked computers appear to users as a single system`,
    options: [
      "A. a-ii, b-i, c-iii, d-iv",
      "B. a-ii, b-i, c-iv, d-iii",
      "C. a-iii, b-iv, c-i, d-ii",
      "D. a-iii, b-i, c-iv, d-ii"
    ],
    answer: "B"
  },
  {
    id: 54,
    question: "Which SQL command removes a table along with its structure from the database?",
    options: ["A. DELETE", "B. TRUNCATE", "C. DROP", "D. REMOVE"],
    answer: "C"
  },
  {
    id: 55,
    question: "The octal equivalent of the binary number (110101)₂ is",
    options: ["A. (56)₈", "B. (53)₈", "C. (35)₈", "D. (65)₈"],
    answer: "D"
  }
];

export default pgcetmcaComputerAwareness;
